import { Badge } from "@/components/ui/badge"
import { useChatPanel } from "../hooks/use-chat-panel"

/** Visible "Draft — not submitted" pill in the panel header.
 *
 *  Only renders while a DRAFT thread exists — so OPEN/RESOLVED/ABANDONED
 *  views and the no-thread welcome state stay clean. Pairs with the
 *  always-visible Submit button so the user can never confuse "I had a
 *  conversation" with "I filed an issue". */
export function DraftBadge() {
  const threadStatus = useChatPanel((s) => s.threadStatus)
  const view = useChatPanel((s) => s.view)
  if (view === "history") return null
  if (threadStatus !== "DRAFT") return null
  return (
    <Badge variant="secondary" className="text-[10px] uppercase">
      Draft — not submitted
    </Badge>
  )
}
